<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <router-link :to="{name: 'survey-view'}">Survey</router-link>
      /
      <b>List</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
        <div class="col-12 col-lg-6 col-sm-12">
        </div>

        <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
            <span class="m-auto"></span>
            <div class="btn-group" role="group">
              <!-- <button class="btn btn-secondary" id="btn-active" type="button" :class = "{ 'change-background' : activeClick }" @click="clickActive()" >Active</button>
              <button class="btn btn-secondary" id="btn-inactive" type="button" :class = "{ 'change-background' : inactiveClick }" @click="clickInactive()">Inactive</button> -->
            </div>
        </div>
        
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Survey</h4>
          

            <div class="table-responsive">
              <table
                id="surveys_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
              
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>IC Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(answer, index) in rows" :key="index">
                    <td>{{index + 1}}</td>
                    <td><router-link :to="goTo(answer.ic_number)">{{answer.ic_number}}</router-link></td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        @click="redirectTo(answer.user_id)"
                      >View</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "view-answer",
  components: {},

  data() {
    return {
        rows: [],
        question: [],
    };
  },

  methods: {
    async loadData() {
      await this.loadAnswer();
      this.createDatatable();
    },

    async loadAnswer() {
      if(this.checkToken() === false) {
        return;
      }
      try {
        let id = this.$route.params.id;
        let result = await axios
          .get(axios.lpsURL + "/survey_user/survey/" +id, {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          });
          this.rows = result.data;

          
          console.log(JSON.stringify(this.rows))
      } catch (error) {
        console.log(error)
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    createDatatable() {
      $("#surveys_tbl").DataTable();
    },

    checkType(str) {
      if(Array.isArray(str)) {
        for(let i = 0; i < str.length; i++) {
          return str[i];
        }
      }

      return str;
    },

    goTo(ic_no) {
      return "/customer/" +ic_no;
    },

    redirectTo(user_id) {
      let id = this.$route.params.id;
      this.$router.push({ 
        name: 'view-user-answer',
        params: { id: id, user_id: user_id }
      });
    }
  },

  async created() {
    this.loadData();
  },

  mounted() {}
};
</script>

